import React from "react";

const SvgLeftArrow = props => <svg width={9} height={16} viewBox="0 0 9 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8.67 14.049c.44.446.44 1.17 0 1.616a1.113 1.113 0 0 1-1.59 0L.33 8.808a1.156 1.156 0 0 1-.034-1.58L6.483.37A1.113 1.113 0 0 1 8.073.3c.458.426.489 1.149.069 1.614l-5.46 6.05L8.67 14.05z" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/left-arrow_00dafd.svg";
export { SvgLeftArrow as ReactComponent };